export default (props, vars) =>
  vars?.['useform1']?.['register']('firstName', { required: true });
